import { handleAsync } from "../../utils";

import {
  TAuthLoginRequestPayload,
  TAuthLoginResponsePayload,
  TAuthRefreshAccessTokenResponsePayload,
  TResetPasswordRequestPayload,
  TResetPasswordResponsePayload,
  TForgotPasswordRequestPayload,
  TForgotPasswordResponsePayload,
  TOnboardUserRequestPayload,
  TOnboardUserResponsePayload,
  TUpdatePasswordRequestPayload,
  TInviteVerificationResponse,
  TRenewPasswordRequestPayload,
  TRenewPasswordResponsePayload,
} from "./auth.types";

import { API } from "../../core/apiurl";
import {
  ApiService,
  TApiServiceError,
  TApiServiceOptions,
} from "../apiService";
import { authenticatedApiService } from "../apiservice.auth";

const apiService = new ApiService();

class AuthService {
  // methods
  login(payload: TAuthLoginRequestPayload, options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TAuthLoginResponsePayload>(() =>
      apiService.post(API.loginEndpoint, payload, options),
    );
  }

  logout(refresh_token: string, options?: TApiServiceOptions) {
    const loginObj = { refresh_token: refresh_token ?? "" };
    return authenticatedApiService.post<void>(
      API.logoutEndpoint,
      loginObj,
      options,
    );
  }

  refreshAccessToken(payload: any, options?: TApiServiceOptions) {
    return handleAsync<
      TApiServiceError,
      TAuthRefreshAccessTokenResponsePayload
    >(() => apiService.post(API.refreshAccessTokenEndpoint, payload, options));
  }

  resetPassword(
    payload: TResetPasswordRequestPayload,
    options?: TApiServiceOptions,
  ) {
    return handleAsync<TApiServiceError, TResetPasswordResponsePayload>(() =>
      apiService.post(API.resetPassword, payload, options),
    );
  }

  forgotPassword(
    payload: TForgotPasswordRequestPayload,
    options?: TApiServiceOptions,
  ) {
    return handleAsync<TApiServiceError, TForgotPasswordResponsePayload>(() =>
      apiService.post(API.forgotPasswordEndpoint, payload, options),
    );
  }

  onboardUser(
    payload: TOnboardUserRequestPayload,
    options?: TApiServiceOptions & { tenantId?: string | undefined },
  ) {
    let url = API.onboardUser;
    if (options?.tenantId) {
      url += `?tid=${options.tenantId}`;
    }
    return handleAsync<TApiServiceError, TOnboardUserResponsePayload>(() =>
      apiService.post(url, payload, options),
    );
  }

  updatePassword(
    payload: TUpdatePasswordRequestPayload,
    query: string,
    options?: TApiServiceOptions,
  ) {
    return handleAsync<TApiServiceError, any>(() =>
      authenticatedApiService.post(
        API.updatePassword + query,
        payload,
        options,
      ),
    );
  }

  inviteVerification(
    id: string,
    options?: TApiServiceOptions & { tenantId?: string | undefined },
  ) {
    let url = `${API.inviteVerification}${id}`;
    if (options?.tenantId) {
      url += `/?tid=${options.tenantId}`;
    }
    return handleAsync<TApiServiceError, TInviteVerificationResponse>(() =>
      apiService.get(url, options),
    );
  }

  renewPassword(
    payload: TRenewPasswordRequestPayload,
    options?: TApiServiceOptions,
  ) {
    return handleAsync<TApiServiceError, TRenewPasswordResponsePayload>(() =>
      apiService.post(API.renewPassword, payload, options),
    );
  }
}

export const authService = new AuthService();
